/**
 * DNR — Digital Net Register — application entry point.
 *
 * Boot order is deliberate (design §8.3). The shell must paint before any
 * data query resolves, so a 50,000-invoice database does not delay first
 * meaningful paint. The shell renders an empty state, then fills.
 *
 * Nothing in this file may touch the network.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './ui/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
